import Accordion from "./Classes/Accordion";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import CV from "./Classes/Cv";
import Video from "./Classes/Video";
import Sticky from "./Classes/Sticky";
import Anchor from "./Classes/Anchor";
import SwiperStartpage from "./Classes/SwiperStartpage";
import CountUpNumbers from "./Classes/CountUpNumbers";

window.addEventListener("page_event_load", () => {
    new Accordion({
        accordions: '.lc-accordion__inner-head',
        pxCorrectionMobile: 110,
        pxCorrectionDesktop: 105,
        mobileBreakpoint: 1025
    });


    new SwiperStartpage();
    new CV();
    new Sticky();
    new Anchor();

    new ResponsiveTablesLight({
        tableComponentSelector: '.lc-component--table',
        tableContainerSelector: '.ns-table-container',
        tableSelector: '.lc-component--table table'
    });

    new CountUpNumbers({
      numbersSelector: '.lc-keyfigure__number--upcount',
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      langArray: ['de'],
      decimalArray: [','],
      decimalPlaces: 0,
      thousandSepArray: [''],
    });

    const videoSettings = {
        videoComponentSelector: '.lc-video', // Replace with your actual selector
        videoButtonSelector: '.lc-video__thumbnail', // Replace with your actual selector
        thumbnailSelector: '.lc-video__thumbnail-container', // Replace with your actual selector
    };

    new Video(videoSettings);

});

window.addEventListener('note_event_load', evt => {
    // console.log("note loaded event");
    document.body.classList.add("note-open");

    new ResponsiveTablesLight({
        tableComponentSelector: '.lc-component--table',
        tableContainerSelector: '.ns-table-container',
        tableSelector: '.lc-component--table table'
    });

});

window.addEventListener('story_event_load', evt => {
    // console.log("note loaded event");
    document.body.classList.add("note-open");

    new ResponsiveTablesLight({
        tableComponentSelector: '.lc-component--table',
        tableContainerSelector: '.ns-table-container',
        tableSelector: '.lc-component--table table'
    });

});



window.addEventListener('story_unloaded', evt => {
    //console.log("note unloaded event");
    document.body.classList.remove("note-open");
});


window.addEventListener('note_unloaded', evt => {
    //console.log("note unloaded event");
    document.body.classList.remove("note-open");
});
